import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ls from 'local-storage'
import Tooltip from '@material-ui/core/Tooltip';

import red from '@material-ui/core/colors/red';
import grey from '@material-ui/core/colors/grey';
import green from '@material-ui/core/colors/green';
import blue from '@material-ui/core/colors/blue';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SendIcon from '@material-ui/icons/Send';

import ClaimENValidate from '../../patient/Claims/ENValidate';

const styles = theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
    },
    button: {
        margin: theme.spacing.unit / 2,
        marginTop: 0,
        marginBottom: 0,
    },
    paper: {
        padding: theme.spacing.unit,
        color: theme.palette.text.secondary,
    },
    tabBar: {
        boxShadow: 'none',
    },
    deleteIcon: {
        fontSize: 24,
        color: grey[500],
        '&:hover': {
            color: red[500],
        },
        marginRight: 4,
    },
    editIcon: {
        fontSize: 24,
        color: grey[500],
        '&:hover': {
            color: blue[500],
        }
    },
    validateIcon: {
        fontSize: 24,
        color: grey[500],
        '&:hover': {
            color: green[500],
        }
    },    
});  

const formstatus={
    '1': 'Not validated',
    '2': 'To send',
    '3': 'Sent',
    '9': 'Deleted',
}

class ClaimsValidate extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.props = props;
    }

    state = {
        holdclaimlist: [],
        user: {},
    };

    getMuiTheme = () => createMuiTheme({
        overrides: {
            MuiTableCell: {
                root: {
                    padding: 0,
                }
            }
        }
    });

    fetchClaims() {
        if (this._isMounted) {
            this.props.socket.emit("claim_list",{patientid:'all',authenticator:ls.get("authenticator")});
        }
    };     

    componentDidMount() {
        this._isMounted = true;  
        
        this.fetchClaims();
        
        this.props.socket.on("claim_list_result",(d)=>{
            if (this._isMounted) {
                this.setState({rawData: d.claimlist});
                this.setState({user: d.user});

                //console.log(d);

                let data = d.claimlist.map((dt, i) => {
                    let claimid = '';
                    if (dt.fp17_id)
                        claimid = dt.fp17_id;
                    else
                        claimid = dt.form_id;

                    let fstatus = 'unknown';
                    if (formstatus[dt.form_status])
                        fstatus = formstatus[dt.form_status]

                    return [claimid, moment(dt.date_started).format("DD/MM/YYYY"), dt.patient_name,
                            dt.displayname, dt.form_data.pchg, dt.short_desc, dt.uda_weight, '', '', dt.form_id];
                });
                this.setState({claimlist: data});
            }
        });           

    }

    componentWillUnmount() {
        this._isMounted = false;
    }  

    handleChange = (event, value) => {
        this.setState({ value });
    };

    handleFormClickOpen = () => {
        this.setState({ formOpen: true });
    }

    handleFormClose = () => {
        this.setState({ form_id: undefined} );
        this.setState({ formOpen: false });
        this.fetchClaims();
    } 

    handleClaimDelete = (tableMeta) => {
        console.log(tableMeta);

        this.setState({action: 'delete', delete_type: 'unsent', delete_id: tableMeta.rowData[0]});
        this.setState({deleteclaimOpen: true});

    }    

    handleDeleteClaimClose = () => {
        this.setState({ action: undefined, delete_type: undefined, delete_id: undefined });
        this.setState({ deleteclaimOpen: false });
    }

    deleteClaim = () => {
        if (this._isMounted) {
            this.props.socket.emit("claim_delete", {type: this.state.delete_type, form_id: this.state.delete_id,authenticator:ls.get("authenticator")});
        }
    }

    handleClaimValidateOpen = (tableMeta) => {
        this.setState({ form_id: tableMeta.rowData[0]} );
        this.setState({ validateclaimOpen: true });
    }    

    handleClaimValidateClose = () => {
        this.setState({ claimdata: {} });
        this.setState({ validateclaimOpen: false });
        
        this.fetchClaims();
    }      

    render() {
        const { classes } = this.props;
        const { claimlist } = this.state;

        const columns=[
            { name: 'ID', options: {filter: false, sort: true,}},
            { name: 'Date Submitted', options: {filter: false, sort: true,}},            
            { name: 'Patient', options: {filter: false, sort: true,}},
            { name: 'Clinician', options: {filter: true, sort: true,}},
            { name: 'Patient Charge', options: {filter: false, sort: true,}},
            { name: 'Band', options: {filter: true, sort: true,}},
            { name: 'UDA', options: {filter: true, sort: true,}},
            { name: 'Category', options: {filter: true, sort: true,}},
            { name: 'Cont', options: {filter: true, sort: true,}},
            { name: 'Options', options: {filter: false, customBodyRender: (value, tableMeta, updateValue) => {
                return (
                    <span>
                        { this.state.user.jobrole === 'D' || this.state.user.staffid === '999' ? 
                        <Tooltip title="Validate & Send Claim">
                            <SendIcon className={classes.validateIcon} onClick={(e) => this.handleClaimValidateOpen(tableMeta, e)}/>
                        </Tooltip> 
                        : null }  
                        <Tooltip title="Delete Claim">
                            <DeleteForeverIcon className={classes.deleteIcon} onClick={(e) => this.handleClaimDelete(tableMeta, e) }/>
                        </Tooltip>
                    </span>
                )
            }}}
        ];   

    return (
        <div className={classes.root}>
            <Grid container style={{ padding: 2 }} spacing={1}>
                <Grid item xs={12}>
                    <MuiThemeProvider theme={this.getMuiTheme()}>
                        <MUIDataTable
                            data={claimlist}
                            columns={columns}
                            title="Claims to validate"
                            options={{
                                filterType: "checkbox",
                                responsive: "standard",
                                textLabels: {
                                    body: {
                                        noMatch: "No claims found!",
                                    },
                                },
                            }}
                        />   
                    </MuiThemeProvider>                 
                </Grid>
            </Grid>
            <Dialog
                open={this.state.deleteclaimOpen}
                onClose={this.handleDeleteClaimClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Delete claim?"}</DialogTitle>
                <DialogContent>
                    { this.state.delete_type === 'unsent' ?
                    <DialogContentText id="alert-dialog-description">
                    The claim ({this.state.delete_id}) has not been sent yet so will be deleted permanently.<br/>Is that OK?
                    </DialogContentText>
                    : 
                    <DialogContentText id="alert-dialog-description">
                    The claim ({this.state.delete_id}) has already been sent.<br/>Do you want to send a schedule query to delete it from compass?<br/>
                    If it's in the batch to send, it'll be deleted.
                    </DialogContentText>
                    }
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={this.handleDeleteClaimClose} color="secondary">
                    No
                    </Button>
                    <Button variant="contained" onClick={this.deleteClaim} color="primary" autoFocus>
                    Yes
                    </Button>
                </DialogActions>
                
            </Dialog>      
            <Dialog
                open={this.state.validateclaimOpen}
                onClose={this.handleClaimValidateClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                <ClaimENValidate closeFunction={this.handleClaimValidateClose} patient_id={this.state.patient_id} 
                    socket={this.props.socket} form_id={this.state.form_id} fp17data={this.state.claimdata}
                    source="claim_list"/>
            </Dialog>             
        </div>    
    );
  }
}

export default withStyles(styles)(ClaimsValidate);